import { render, staticRenderFns } from "./SettingsSalary.vue?vue&type=template&id=4de437a6&scoped=true&"
import script from "./SettingsSalary.vue?vue&type=script&lang=js&"
export * from "./SettingsSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de437a6",
  null
  
)

export default component.exports